// extracted by mini-css-extract-plugin
module.exports = {"container":"TakeCareDrawer_container__2OSQr","info":"TakeCareDrawer_info__1woLw","label":"TakeCareDrawer_label__3goJm","takeCareDrawer":"TakeCareDrawer_takeCareDrawer__9Vw22"};